import isString from '#shared/util/isString.js';
import updateStoreData from '#shared/util/updateStoreData.js';
import { cartFactory } from '#shared/model/Cart.js';

export default {
	async changeVariation({ commit, state }, { oldProduct, newProduct }) {
		commit('SET_LOADER', true);
		try {
			const response = await cartFactory(state).replaceProduct({
				oldProduct,
				newProduct
			});
			commit('SET_ORDER', response.data.order);
		} catch (error) {
			commit('SET_ERROR', error);
		}
		commit('SET_LOADER', false);
	},
	async changeQuantity({ commit, state }, { product, quantity }) {
		commit('SET_LOADER', true);
		try {
			const response = await cartFactory(state).updateProductQuantity({
				product,
				quantity
			});
			commit('SET_ORDER', response.data.order);
		} catch (error) {
			commit('SET_ERROR', error);
		}
		commit('SET_LOADER', false);
	},
	async removeProduct({ commit, state }, { product }) {
		commit('SET_LOADER', true);
		try {
			const response = await cartFactory(state).removeProduct({
				product
			});
			commit('SET_ORDER', response.data.order);
		} catch (error) {
			commit('SET_ERROR', error);
		}
		commit('SET_LOADER', false);
	},
	async addProduct({ commit, state }, { product, quantity, hideLoader = true }) {
		commit('SET_LOADER', true);
		try {
			const response = await cartFactory(state).addProduct({
				product,
				quantity
			});
			commit('SET_ORDER', response.data.order);
		} catch (error) {
			commit('SET_ERROR', error);
		}
		if (hideLoader) { // In some cases we do not want to hide loader after adding the product to prevent flashing of the loading overlay
			commit('SET_LOADER', false);
		}
	},
	async applyBilling({ commit, state }, applyBillingPayload) {
		const response = await cartFactory(state).applyBilling(applyBillingPayload);
		updateStoreData({
			commit
		}, response.data);
		return response;
	},
	async removeBilling({ commit, state }) {
		const response = await cartFactory(state).removeBilling();
		updateStoreData({
			commit
		}, response.data);
		return response;
	},
	async applyForm({ commit, state }, applyFormPayload) {
		const response = await cartFactory(state).applyForm(applyFormPayload);
		updateStoreData({
			commit
		}, response.data);
		return response;
	},
	async applyCompany({ commit, state }, applyCompanyPayload) {
		const response = await cartFactory(state).applyCompany(applyCompanyPayload);
		updateStoreData({
			commit
		}, response.data);
		return response;
	},
	async applyPayment({ commit, state }, applyPaymentPayload) {
		const response = await cartFactory(state).applyPayment(applyPaymentPayload);
		updateStoreData({
			commit
		}, {
			...response.data,
			customer: response.data.payment.owner || state.customer
		});
		return response;
	},
	async submitOrder({ commit, state }, submitOrderPayload) {
		const response = await cartFactory(state).submitOrder(submitOrderPayload);
		if (isString(response.data.paymentUrl)) {
			return response;
		}
		updateStoreData({
			commit
		}, response.data);
		return response;
	},
	async getCart({ commit, state }) {
		const response = await cartFactory(state).getCart();
		updateStoreData({
			commit
		}, response.data);
		// We need to set selected payment method type in order to load provider inputs correctly
		if (state.order.isAuthenticated) {
			commit('SET_SELECTED_PAYMENT', {
				type: state.payment.type
			});
		}
		return response;
	},
	openCart({ state }, cartData) {
		return cartFactory(state).openCart(cartData);
	}
};
